import { useState } from "react";
import { Sheet } from "./Sheet";
import { useT, useAmount } from "../../lib/LocaleContext";

// Presets in stored ounces — shown in whichever unit the caretaker prefers.
const PRESET_OZ = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 6];

export function FeedSheet({
  open,
  defaultOz,
  onSubmit,
  onClose,
}: {
  open: boolean;
  defaultOz: number;
  onSubmit: (oz: number) => void;
  onClose: () => void;
}) {
  const t = useT();
  const amount = useAmount();
  // `oz` is the source of truth (always ounces); `text` mirrors the custom field
  // in the active unit so typing a decimal isn't fought by re-rounding.
  const [oz, setOz] = useState(defaultOz);
  const [text, setText] = useState(() => String(amount.value(defaultOz)));

  function reset() {
    setOz(defaultOz);
    setText(String(amount.value(defaultOz)));
  }

  function handleClose() {
    reset();
    onClose();
  }

  function pickPreset(value: number) {
    setOz(value);
    setText(String(amount.value(value)));
  }

  function onText(raw: string) {
    setText(raw);
    const n = Number(raw);
    if (raw.trim() !== "" && Number.isFinite(n)) setOz(amount.toOz(n));
    else setOz(0);
  }

  function commit() {
    onSubmit(oz);
    reset();
  }

  return (
    <Sheet open={open} onClose={handleClose} title={t.feedSheet.title}>
      <p className="muted sheet__caption">{t.feedSheet.howMuch}</p>
      <div className="oz-grid">
        {PRESET_OZ.map((value) => (
          <button
            key={value}
            type="button"
            className={`oz-chip ${value === oz ? "oz-chip--selected" : ""}`}
            onClick={() => pickPreset(value)}
          >
            {amount.fmt(value)}
          </button>
        ))}
      </div>

      <label className="field" style={{ marginTop: "1rem" }}>
        <span className="field__label">{t.feedSheet.customAmount(amount.word)}</span>
        <input
          className="field__input"
          type="number"
          inputMode="decimal"
          step={amount.unit === "ml" ? "5" : "0.5"}
          min="0"
          value={text}
          onChange={(e) => onText(e.target.value)}
        />
      </label>

      <button
        type="button"
        className="btn btn--primary btn--block"
        style={{ marginTop: "1rem" }}
        disabled={oz <= 0}
        onClick={commit}
      >
        {t.feedSheet.logFeed(amount.fmt(oz))}
      </button>
    </Sheet>
  );
}
